import React, { useEffect, forwardRef } from "react";

const AudioPlayer = forwardRef(function AudioPlayer(
  { key, src, onCanPlayThrough, onEnded },
  ref
) {
  useEffect(() => {
    return () => {
      // cleanup
      if (ref?.current) {
        ref.current.pause();
        ref.current.src = "";
        ref.current.load();
      }
    };
  }, [ref]);

  return (
    <audio
      ref={ref}
      key={key}
      src={src}
      onCanPlayThrough={onCanPlayThrough}
      onEnded={onEnded}
      preload="auto"
    />
  );
});

export default AudioPlayer;
